import { GHLLanguageKeys as o } from "./ghl-ui.es285.js";
import r from "./ghl-ui.es1273.js";
const t = {
  name: o.croatian,
  locale: r
};
export {
  t as date_hr
};
